const renderPackages = (searchResultsData) => {
  const priceDisplay = searchResultsData.formData.priceDisplay;
  searchResultsData.data.forEach((element) => {
    let myElement = document.createElement('wj-package');
    
    myElement.dataset.packageElement = JSON.stringify(element);    
    myElement.dataset.priceDisplay =  priceDisplay;

    searchResultsData.target.appendChild(myElement);
  });
};
export default renderPackages;
